import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import type { FreeBonusTab } from '../../constants/free-bonus'
import { isFreeBonusTab } from '../../constants/free-bonus'
import { profileRoute } from '.'

const FreeBonus = lazyRouteComponent(
  () => import('../../pages/profile/free-bonus'),
)

// `tab` stays optional: with no tab the page shows the bonus menu, and a tab
// opens that bonus. (Unlike financial-transaction, there is no sensible
// default here — defaulting would skip the menu entirely.)
type FreeBonusSearch = {
  tab?: FreeBonusTab
}

export const freeBonusRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'free-bonus',
  component: FreeBonus,
  validateSearch: (search: Record<string, unknown>): FreeBonusSearch =>
    isFreeBonusTab(search.tab) ? { tab: search.tab } : {},
})
